import { Link } from 'react-router-dom';
import { DayList } from '../components/DayList';
import { Button, Card, Chip, EmptyState, Heading, Row, Screen, Title } from '../components/ui';
import { useSession, type Me } from '../lib/session';

/**
 * Staff phone home (§7). Phase 2 establishes the signed-in shell and the role
 * gates; the day list and follow-ups arrive with bookings (Phase 4) and
 * post-call notes (Phase 6).
 */
export default function Home({ me }: { me: Me }) {
  const { signOut } = useSession();

  return (
    <Screen>
      <Title sub={`${me.staff.name} · ${me.staff.role === 'admin' ? 'Admin' : 'Sales'}`}>Mulaqaat</Title>

      <Card>
        <Heading>Today</Heading>
        <DayList emptyLine="Nothing booked today." />
        <Row className="rec__actions">
          <Link to="/book" className="btn btn--primary">
            New appointment
          </Link>
        </Row>
      </Card>

      <Card>
        <Heading>Follow-ups due</Heading>
        <EmptyState line="Nothing due. Follow-ups appear here after calls are saved." />
      </Card>

      <Card>
        <Heading level={3}>People</Heading>
        <Row>
          <Link to="/customers" className="btn btn--secondary">
            Customers
          </Link>
        </Row>
      </Card>

      <Card>
        <Heading level={3}>This device</Heading>
        <Row>
          <Chip tone="info">Phone</Chip>
          {/* §3: the Start Mulaqaat action does not render on phones — at all. */}
          <Chip tone="neutral">Calls start at the cart</Chip>
        </Row>
      </Card>

      {me.staff.role === 'admin' ? (
        <Card>
          <Heading level={3}>Admin</Heading>
          <Row>
            <Link to="/admin" className="btn btn--secondary">
              Carts &amp; activity
            </Link>
          </Row>
        </Card>
      ) : null}

      <Row className="signout-row">
        <Button variant="ghost" onClick={() => void signOut()}>
          Sign out
        </Button>
      </Row>
    </Screen>
  );
}
